// Ecomail: links with href "#ecomailPopup" reopen the signup popup.
// The widget renders the form DOM on every visit (the ecwshown cookie only
// blocks auto-triggering) and its close buttons merely set display:none, so
// reopening means showing the holder again. Device targeting needs no handling
// here: widget.js UA-gates at load, so exactly one holder (desktop cover OR
// mobile holder) exists in the DOM — we open whichever Ecomail rendered.
// Close buttons are wired inside the widget's showPopup(), which may never
// have run this page load — wire any unbound ones the same way it does.
document.addEventListener('click', (event) => {
  const link = event.target.closest('a[href$="#ecomailPopup"]');
  if (!link) return;
  event.preventDefault();

  const target = document.querySelector('#ec-v-from-popup-cover, #ec-v-from-mobile-popup-holder');
  if (!target) return;

  target.style.display = 'block';

  // mirror the widget's showPopup(): cap holder height, bind close if unbound
  const scope = target.closest('[id^="ec_form_"]') || target;
  scope.querySelectorAll('.ec-v-form-holder').forEach((holder) => {
    holder.style.maxHeight = window.innerHeight + 'px';
  });
  const hide = () => ((target.style.display = 'none'), false);
  scope.querySelectorAll('#ec-v-form-close, .ec-v-form-btntype-close').forEach((btn) => {
    if (!btn.onclick) btn.onclick = hide;
  });
});
